import React from 'react';
import './index.scss';
import { ALIGNMENT_SCORE, TYPICAL_RANGE, RANKED_COLUMNS, HEADER_TEXT } from './constants';
import SectionHeader from '../../../../../SectionHeader';

const LeadershipTeamAlignment = (props) => {
    let alignmentScoreData = props.fetchBenchmarkAlignmentScoreApi.data ? props.fetchBenchmarkAlignmentScoreApi.data : {}
    return (
        <>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />
        <div className='cardwrapper'>
            <div className='lt-align'>
                {/* Summary: the headline alignment score, its typical range, and what it means */}
                <div className='lt-align__summary'>
                        <span className='lt-align__score'>{alignmentScoreData.alignmentScore}%</span>
                    <div className='lt-align__summary-head'>
                        <span className='lt-align__summary-title'>Alignment score</span>
                        <span className='lt-align__summary-range'>
                            Typical range {TYPICAL_RANGE.min}–{TYPICAL_RANGE.max}%
                        </span>
                    </div>
                    <div className='lt-align__summary-desc'>
                        Share of top-ranked critical skills that appear in both groups' priority
                        list. Below the {TYPICAL_RANGE.min}–{TYPICAL_RANGE.max}% typical range usually
                        signals a conversation is needed about where leadership focus should go.
                    </div>
                </div>

                {/* The two ranked-critical lists, side by side */}
                <div className='lt-align__columns'>
                    {RANKED_COLUMNS.map((column) => (
                        <div className='lt-align__card' key={column.title}>
                            <div className='lt-align__card-head'>{column.title}</div>
                            <div className='lt-align__list'>
                                {alignmentScoreData[column.key] && alignmentScoreData[column.key].map((item, i) => (
                                    <div className='lt-align__item' key={item.skill}>
                                        <div className='lt-align__item-head'>
                                            <span className='lt-align__rank'>{i + 1}</span>
                                            <span className='lt-align__skill'>{item.skill}</span>
                                            <span className='lt-align__pct'>{item.pct}%</span>
                                        </div>
                                        <div className='lt-align__track'>
                                            <div
                                                className='lt-align__fill'
                                                style={{ width: `${item.pct}%` }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </>
    );
};

export default LeadershipTeamAlignment;
